// extracted by mini-css-extract-plugin
module.exports = {"page_list":"page_list-2xOLBFU- clearfix","current":"current-2C5WfzL9"};